var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavbarDtvLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 22,
    viewBox: "0 0 113 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3781_6875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.5111 15.0578C73.1004 16.9391 71.8676 18.0486 70.041 18.0486C68.8481 18.0486 67.789 17.5892 67.0595 16.4323C66.3636 15.3272 66.4333 12.8189 66.4333 12.051C66.4333 12.051 66.4143 7.77024 66.5518 7.24298C64.9248 7.17579 63.3979 7.12844 62.3952 7.10156C62.2501 7.73952 62.2862 12.5994 62.2862 12.5994H62.2869C62.2983 14.9567 62.4681 17.0805 63.7903 18.7857C65.2049 20.6094 67.4721 21.7228 70.034 21.7228C74.4162 21.7228 77.2101 18.7307 77.7228 15.0572H73.5111V15.0578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0483 5.63623C67.1915 5.39116 67.9527 3.95015 70.0545 3.95015C71.6187 3.95015 72.7133 4.76856 73.261 6.14878C74.7238 6.31834 76.226 6.53206 77.7053 6.80081C77.1621 3.20406 74.4804 0.276611 70.0621 0.276611C68.4344 0.276611 66.9101 0.70725 65.8687 1.3708C64.089 2.50531 63.1497 3.85161 62.6914 5.49738C63.7119 5.5089 65.2324 5.54217 67.0483 5.63687",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7836 2.45858C12.4354 1.03293 10.4643 0.443604 7.98985 0.443604H0.716797V16.2793C2.03387 15.7559 3.39468 15.2472 4.79985 14.7526V4.11587H7.92203C9.2689 4.11587 10.2855 4.5913 10.9358 5.42122C11.723 6.42583 11.7997 7.27495 11.7997 12.5194C13.1326 12.1355 15.8961 11.4066 15.8961 11.4066C15.8961 6.32089 15.8974 4.6924 13.7836 2.45794",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0137 12.451C40.6376 11.8572 42.1087 10.5576 42.6271 8.53687C38.944 9.09996 33.2688 10.0918 27.8643 11.5161V21.5482H31.9416V13.1312H34.8781L38.9554 21.5482H43.6793L39.0144 12.4516L39.0137 12.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0384 17.831H50.3859V12.7478H58.6313V12.7177H58.6332V9.05376H50.3859V7.60571C49.0429 7.72793 47.6833 7.8719 46.3086 8.03891V21.5487H60.0681V17.8719H60.0384V17.8316V17.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26537 21.5488C10.4356 21.5488 12.4036 20.923 13.784 19.5274C15.0073 18.2931 15.5289 16.8643 15.7482 15.3298C10.7721 17.2021 6.30941 19.3035 2.44629 21.5488H8.26473H8.26537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6709 21.5481H23.7482V12.655C22.3583 13.0652 20.9994 13.4933 19.6709 13.9373V21.5474V21.5481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6709 10.4928C21.0019 10.1882 22.3627 9.89645 23.7482 9.61555V0.453125H19.6709V10.4922V10.4928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0384 0.452637H46.3086V6.28001C47.6719 6.15268 49.0327 6.03942 50.3859 5.9428V4.12554H60.0681V0.453916H60.0384V0.452637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.794 21.5481H102.741L95.8467 0.453857H100.069L104.267 14.1978L108.463 0.453857H112.717L105.794 21.5481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3798 4.12539V21.548H84.3006V4.12539H78.8428V0.453125H93.8364V4.12539H88.3798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9406 4.12545H35.7841C37.5271 4.12545 38.7491 5.14797 38.7491 7.12904L42.8188 6.63569C42.6921 3.23474 40.1936 0.451904 36.0516 0.451904H27.8633V8.82663C29.2101 8.5822 30.5703 8.34801 31.9406 8.12533V4.12545Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3781_6875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 21.4468,
    fill: "white",
    transform: "translate(0.716797 0.276611)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarDtvLogo);
export default __webpack_public_path__ + "static/media/navbar-DTV-logo.fe052cc05faf08001f542a7d1876b185.svg";
export { ForwardRef as ReactComponent };